import { runInAction } from 'mobx';
import { temporaryGiftCardDomainStore } from '../store';
export const clearGiftCardDetails = () => {
    runInAction(() => {
        temporaryGiftCardDomainStore.data.giftCardDetails = undefined;
    });
};
